import React, { useEffect, useState } from 'react';
import { Smartphone, Share2, PlusSquare } from 'lucide-react';
import logger from '../utils/logger';

const HomeScreenInstructions = ({ onClose }) => {
  const [deviceType, setDeviceType] = useState('unknown');
  
  useEffect(() => {
    // Detect device type based on user agent
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setDeviceType('ios');
      logger.debug('Device detected: iOS');
    } else if (/android/i.test(userAgent)) {
      setDeviceType('android');
      logger.debug('Device detected: Android');
    } else {
      setDeviceType('other');
      logger.debug('Device detected: Other');
    }
  }, []);

  const renderInstructions = () => {
    switch (deviceType) {
      case 'ios':
        return (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Add to Home Screen on iOS</h3>
            <ol className="list-decimal pl-5 space-y-3">
              <li>Tap the <Share2 className="inline h-5 w-5 text-blue-500" /> share icon at the bottom of your browser</li>
              <li>Scroll down and tap <strong>"Add to Home Screen"</strong></li>
              <li>Tap <strong>"Add"</strong> in the top right corner</li>
            </ol>
            <div className="mt-4 p-3 bg-blue-100 rounded-md">
              <p className="text-sm text-blue-800">
                <strong>Tip:</strong> You'll now have a shortcut icon on your home screen for quick access!
              </p>
            </div>
          </div>
        );
      
      case 'android':
        return (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Add to Home Screen on Android</h3>
            <ol className="list-decimal pl-5 space-y-3">
              <li>Tap the menu icon (⋮) in the top right of your browser</li>
              <li>Tap <strong>"Add to Home screen"</strong> or <strong>"Install app"</strong></li>
              <li>Tap <strong>"Add"</strong> when prompted</li>
            </ol>
            <div className="mt-4 p-3 bg-blue-100 rounded-md">
              <p className="text-sm text-blue-800">
                <strong>Tip:</strong> Different Android browsers may have slightly different steps, but the option is usually in the main menu.
              </p>
            </div>
          </div>
        );
      
      default:
        return (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Add to Home Screen</h3>
            <p>
              To add this app to your home screen, please open this website on your mobile device using Safari (iOS) or Chrome (Android).
            </p>
            <div className="mt-4 p-3 bg-yellow-100 rounded-md">
              <p className="text-sm text-yellow-800">
                <strong>Note:</strong> This feature is only available on mobile devices.
              </p>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-center mb-6">
        <Smartphone className="h-10 w-10 text-blue-500 mr-3" />
        <h2 className="text-2xl font-bold">Add to Home Screen</h2>
      </div>
      
      <div className="mb-6">
        <p className="text-gray-600">
          Add Mental Edge Coach to your home screen for quick access, just like a native app!
        </p>
      </div>
      
      {renderInstructions()}
      
      <div className="mt-8 flex justify-end">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default HomeScreenInstructions;
